import React from 'react';
import {
  FormSectionType,
  RICMetadata,
} from '@upstart/harmony/lib/legos/ricForm/ricFormTypes';
import { FinanceResponseData } from '@upstart/harmony/lib/legos/financingTypes';
import { Condition } from '@upstart/harmony/lib/legos/constants';
import {
  formatCurrency,
  calculateSumValue,
} from '@upstart/harmony/lib/ric-form-utils';
import { renderElement } from './SchemaFormElementRenderer';
import { LineItem } from '../Components';

export const SchemaSection = ({
  formElement,
  responseData,
  fetchResponseWithUpdatedData,
  ricMetadata,
}: {
  formElement: FormSectionType;
  responseData: FinanceResponseData;
  fetchResponseWithUpdatedData: (data: Partial<FinanceResponseData>) => void;
  ricMetadata?: RICMetadata;
}) => {
  const {
    title,
    subtitle,
    value,
    sumValue,
    sectionElements,
    options = {},
  } = formElement;

  const { onlyShowForUsedCar } = options;

  if (onlyShowForUsedCar && responseData.carCondition === Condition.NEW) {
    // Both Used and CPO cars are considered used
    return null;
  }

  const strValue = sumValue
    ? formatCurrency(calculateSumValue(responseData, sumValue))
    : value ?? '';

  const renderSectionElements = () =>
    sectionElements?.map(sectionElement =>
      renderElement({
        formElement: sectionElement,
        responseData,
        fetchResponseWithUpdatedData,
        ricMetadata,
      }),
    );

  return (
    <>
      <LineItem title={title} subtitle={subtitle} value={strValue} />
      <div className="form-section">
        {sectionElements && renderSectionElements()}
      </div>
    </>
  );
};

export default SchemaSection;
